import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
    TextField,
    Box,
    Typography,
    Button,
    Checkbox,
    FormControlLabel,
    FormControl,
    RadioGroup,
    Radio,
    FormLabel,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import "../global/formCourse.css";
import CircularProgress from "@mui/material/CircularProgress";
import {fontType} from "../../constants/font";

const VoucherOrderForm = ({ voucher, onCloseHandler }) => {
    const [SubmitDisabled, setSubmitDisabled] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const SITE_KEY = process.env.REACT_APP_SITE_KEY;
    const recaptchaRef = useRef(null);

    const handleExpiredToken = () => {
        let token = recaptchaRef.current.getValue();
        if (token) {
            setSubmitDisabled(false);
        } else setSubmitDisabled(true);
    };

    const textStyle = {
        "& .MuiOutlinedInput-root": {
            "& input": {
                fontFamily: fontType.regular, // Font family for the input text
            },
            "& input::placeholder": {
                fontFamily: fontType.regular, // Font family for the placeholder text
            },
        },
        "& .MuiInputLabel-root": {
            typography: {
                fontFamily: fontType.regular, // Font family for the placeholder text
            },
        },
    };

    const checkBox = {
        height: "20px",
        "& .MuiTypography-root": {
            fontFamily: fontType.regular,
            fontSize: 14,
        },
    };

    const [sukromnaOsoba, setSukromnaOsoba] = useState(true);
    const [suhlasObchodnePodmienky, setObchodnePodmienky] = useState(false);
    const [platbaTyp, setPlatbaTyp] = useState("faktura");
    const [formValues, setFormValues] = useState({
        menoPriezvisko: "",
        sukromnaOsoba: true,
        ulicaPopisneCislo: "",
        mesto: "",
        psc: "",
        spolocnost: "",
        ico: "",
        email: "",
        telefon: "",
        poznamka: `Predbežne objednávam poukaz v hodnote ${voucher}€`,
        suhlasObchodnePodmienky: false,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const handleSukromnaOsobaChange = (e) => {
        setSukromnaOsoba(e.target.checked);
    };

    const handleSuhlasObchodnePodmienkyChange = (e) => {
        setObchodnePodmienky(e.target.checked);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setSubmitDisabled(true);

        const requestBody = sukromnaOsoba
            ? {
                voucher: voucher,
                contact_name: formValues.menoPriezvisko,
                email: formValues.email,
                phone: formValues.telefon,
                no_participants: formValues.pocetUcastnikov,
                payment_type: "invoice",
                note: formValues.poznamka,
                street: formValues.ulicaPopisneCislo,
                city: formValues.mesto,
                psc: formValues.psc,
                g_recaptcha_response: recaptchaRef.current.getValue(),
            }
            : {
                voucher: voucher,
                contact_name: formValues.menoPriezvisko,
                email: formValues.email,
                phone: formValues.telefon,
                no_participants: formValues.pocetUcastnikov,
                payment_type: "invoice",
                note: formValues.poznamka,
                street: null,
                city: null,
                psc: null,
                ico: formValues.ico,
                company_name: formValues.spolocnost,
                g_recaptcha_response: recaptchaRef.current.getValue(),
            };

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}voucher/create_order`, requestBody);
            setSubmitted(true);
            setLoading(false);
            setSubmitDisabled(false);
        } catch (error) {
            setErrorMessage(error.response.data.message);
            setErrorModal(true);
            setLoading(false);
            setSubmitDisabled(false);
        }
    };

    function handleModalBgClick(e) {
        if (e.target.id === "bgVoucherOrderModal") {
            onCloseHandler();
        }
    }

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(128, 128, 128, 0.5)", // Grey color with 50% opacity
                overflow: "auto",
                zIndex: 50, // Set an appropriate z-index value
                justifyContent: "center",
            }}
        >
            <Box
                onClick={handleModalBgClick}
                id="bgVoucherOrderModal"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "50px",
                    paddingBottom: "50px",
                    alignItems: "center"
                }}
            >
                <Box sx={{ display: "flex" }}>
                    {!submitted && !errorModal && (
                        <Box
                            sx={{
                                background: "white",
                                zIndex: 5,
                                maxWidth: "300px",
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                borderRadius: "22px",
                                border: "1px solid",
                                borderColor: "black",
                                paddingBottom: "20px",
                            }}
                        >
                            <form onSubmit={handleSubmit}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "end",
                                        marginTop: "10px",
                                    }}
                                >
                                    <img onClick={onCloseHandler} style={{ cursor: "pointer", rotate: "45deg" }} src={require("../../assets/red_plus.png")} alt="arrow_close" />
                                </Box>
                                <TextField
                                    sx={textStyle}
                                    id="meno-priezvisko"
                                    label="Meno a Priezvisko"
                                    placeholder="Meno a Priezvisko"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="menoPriezvisko"
                                    value={formValues.menoPriezvisko}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        maxLength: 30, // Maximum character limit
                                    }}
                                />

                                <FormControlLabel
                                    control={<Checkbox checked={sukromnaOsoba} onChange={handleSukromnaOsobaChange} name="sukromnaOsoba" />}
                                    label="Súkromná osoba"
                                    sx={checkBox}
                                />

                                {sukromnaOsoba ? (
                                    <>
                                        <TextField
                                            sx={textStyle}
                                            id="ulica-popisne-cislo"
                                            label="Ulica a popisné číslo"
                                            placeholder="Ulica a popisné číslo"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            required
                                            name="ulicaPopisneCislo"
                                            value={formValues.ulicaPopisneCislo}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                maxLength: 50, // Maximum character limit
                                            }}
                                        />

                                        <TextField
                                            sx={textStyle}
                                            id="mesto"
                                            label="Mesto"
                                            placeholder="Mesto"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            required
                                            name="mesto"
                                            value={formValues.mesto}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                maxLength: 30, // Maximum character limit
                                            }}
                                        />

                                        <TextField
                                            sx={textStyle}
                                            id="psc"
                                            label="PSČ"
                                            placeholder="PSČ"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            required
                                            name="psc"
                                            value={formValues.psc}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                maxLength: 6, // Maximum character limit
                                            }}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <TextField
                                            sx={textStyle}
                                            id="spolocnost"
                                            label="Spoločnosť"
                                            placeholder="Spoločnosť"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            required
                                            name="spolocnost"
                                            value={formValues.spolocnost}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                maxLength: 50, // Maximum character limit
                                            }}
                                        />

                                        <TextField
                                            sx={textStyle}
                                            id="ico"
                                            label="IČO"
                                            placeholder="IČO"
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            required
                                            name="ico"
                                            value={formValues.ico}
                                            onChange={handleInputChange}
                                            inputProps={{
                                                maxLength: 12, // Maximum character limit
                                            }}
                                        />
                                    </>
                                )}

                                <TextField
                                    sx={textStyle}
                                    id="email"
                                    label="E-mail"
                                    placeholder="E-mail"
                                    type="email"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="email"
                                    value={formValues.email}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        maxLength: 50, // Maximum character limit
                                    }}
                                />

                                <TextField
                                    sx={textStyle}
                                    id="telefon"
                                    label="Telefón"
                                    placeholder="Telefón"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="telefon"
                                    value={formValues.telefon}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        maxLength: 15, // Maximum character limit
                                    }}
                                />

                                <TextField
                                    sx={textStyle}
                                    id="poznamka"
                                    label="Poznámka"
                                    placeholder="Poznámka"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    required
                                    name="poznamka"
                                    value={formValues.poznamka}
                                    onChange={handleInputChange}
                                    inputProps={{
                                        maxLength: 1000,
                                    }}
                                />

                                <FormControl component="fieldset" margin="normal">
                                    <FormLabel sx={{ fontFamily: fontType.regular }} component="legend">
                                        Spôsob platby
                                    </FormLabel>
                                    <RadioGroup aria-label="platba-typ" name="platbaTyp" value={platbaTyp}>
                                        <FormControlLabel
                                            value="faktura"
                                            control={<Radio />}
                                            label={
                                                <Typography
                                                    variant="body1"
                                                    sx={{
                                                        fontFamily: fontType.regular, // Font family for the label
                                                    }}
                                                >
                                                    Platba cez faktúru
                                                </Typography>
                                            }
                                        />
                                    </RadioGroup>
                                </FormControl>

                                <Box sx={{ marginTop: "15px", height: "20px" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={suhlasObchodnePodmienky}
                                                onChange={handleSuhlasObchodnePodmienkyChange}
                                                name="suhlasObchodnePodmienky"
                                                sx={{
                                                    marginTop: "-22px",
                                                }}
                                                required
                                            />
                                        }
                                        label={
                                            <Typography>
                                                Súhlas s{" "}
                                                <Link target="_blank" rel="noopener noreferrer" to="https://aas-academy.sk/dokumenty/obchodne_podmienky">
                                                    obchodnými podmienkami
                                                </Link>
                                            </Typography>
                                        }
                                        sx={checkBox}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        height: "auto",
                                        width: "100%",
                                        marginTop: "10px",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <ReCAPTCHA ref={recaptchaRef} sitekey={SITE_KEY} onChange={handleExpiredToken} />
                                </Box>
                                <Box sx={{ width: "100%", display: "flex", justifyContent: "end" }}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={
                                            !suhlasObchodnePodmienky || SubmitDisabled
                                        }
                                        sx={{ fontFamily: fontType.regular, fontSize: 16 }}
                                    >
                                        {loading ? <CircularProgress size={20} /> : "Objednať"}
                                    </Button>
                                </Box>
                            </form>
                        </Box>
                    )}
                    {submitted && (
                        <Box
                            sx={{
                                maxWidth: "500px",
                                width: "100%",
                                backgroundColor: "white",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "50px",
                                paddingBottom: "50px",
                                paddingLeft: {sm: "25px", xs: "10px"},
                                paddingRight: {sm: "25px", xs: "10px"},
                                borderRadius: "22px",
                                position: "relative",
                                marginLeft: "15px",
                                marginRight: "15px",
                                top: "30vh",
                            }}
                        >
                            <img
                                onClick={onCloseHandler}
                                style={{
                                    cursor: "pointer",
                                    rotate: "45deg",
                                    position: "absolute",
                                    right: 10,
                                    top: 10,
                                }}
                                src={require("../../assets/red_plus.png")}
                                alt="arrow_close"
                            />
                            <Typography
                                sx={{
                                    color: "#1b144a",
                                    fontFamily: fontType.semiBold,
                                    fontSize: "28px",
                                    lineHeight: "22px",
                                    marginBottom: "5px",
                                    textAlign: { md: "start", xs: "center" },
                                }}
                            >
                                Super!
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#1b144a",
                                    fontFamily: fontType.semiBold,
                                    fontSize: { md: "22px", xs: "18px" },
                                    lineHeight: "22px",
                                    marginBottom: "5px",
                                    textAlign: { md: "start", xs: "center" },
                                }}
                            >
                                Tvoju objednávku sme úspešne zaregistrovali.
                            </Typography>
                            <img src={require("../../assets/confetti.png")} alt="confetti" />
                        </Box>
                    )}
                    {errorModal && (
                        <Box
                            sx={{
                                maxWidth: "500px",
                                width: "100%",
                                backgroundColor: "white",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "50px",
                                paddingBottom: "50px",
                                paddingLeft: {sm: "25px", xs: "10px"},
                                paddingRight: {sm: "25px", xs: "10px"},
                                borderRadius: "22px",
                                position: "relative",
                                marginLeft: "15px",
                                marginRight: "15px",
                                top: "30vh",
                            }}
                        >
                            <img
                                onClick={onCloseHandler}
                                style={{
                                    cursor: "pointer",
                                    rotate: "45deg",
                                    position: "absolute",
                                    right: 10,
                                    top: 10,
                                }}
                                src={require("../../assets/red_plus.png")}
                                alt="arrow_close"
                            />
                            <Typography
                                sx={{
                                    color: "#1b144a",
                                    fontFamily: fontType.semiBold,
                                    fontSize: "28px",
                                    lineHeight: "22px",
                                    marginBottom: "5px",
                                    textAlign: { md: "start", xs: "center" },
                                }}
                            >
                                Nastala chyba
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#1b144a",
                                    fontFamily: fontType.semiBold,
                                    fontSize: { md: "22px", xs: "18px" },
                                    lineHeight: "22px",
                                    marginBottom: "5px",
                                    textAlign: { md: "start", xs: "center" },
                                }}
                            >
                                {errorMessage}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default VoucherOrderForm;
